<template>
  <div class="h-full">
    <div
      class="bg-white border border-gray-100 rounded-xl p-4 flex flex-col justify-between h-full min-h-[120px]"
    >
      <div class="flex justify-between items-start mb-2">
        <h2
          class="text-2xl font-semibold leading-10 text-gray-900 m-0 tabular-nums"
        >
          {{ formattedValue }}
        </h2>
        <div class="icon-wrapper relative flex-shrink-0">
          <div
            class="w-10 h-10 rounded-[22px] bg-[#cef1f3] flex items-center justify-center relative z-10"
          >
            <slot name="icon">
              <i class="pi pi-chart-bar text-[#06BBC4] text-base" />
            </slot>
          </div>
          <!-- Pulsing ring -->
          <span class="pulse-ring" />
        </div>
      </div>

      <!-- Label -->
      <div class="mb-3">
        <p class="text-base font-medium text-gray-900 m-0">{{ label }}</p>
      </div>

      <!-- Progress bar (optional) -->
      <!-- <div v-if="showProgress" class="mb-2">
        <div class="h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div
            class="h-full rounded-full bg-[#06BBC4] transition-all duration-500"
            :style="{ width: Math.min(100, Math.max(0, progressVal)) + '%' }"
          />
        </div>
      </div> -->

      <!-- Subtext / description -->
      <div v-if="subtext" class="mt-auto">
        <p class="text-base text-gray-500 m-0" v-html="subtext" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";

const props = defineProps({
  label: { type: String, default: "" },
  value: { type: [String, Number], default: null },
  suffix: { type: String, default: "" },
  subtext: { type: String, default: "" },
  asProgress: { type: Boolean, default: false },
  progress: { type: Number, default: null },
});

// const progressVal = computed(() =>
//   props.progress != null ? props.progress : Number(props.value) || 0,
// );
// const showProgress = computed(() => props.asProgress || props.progress != null);

const formattedValue = computed(() => {
  if (props.value == null) return "—";
  const base = String(props.value);
  return props.suffix ? `${base}${props.suffix}` : base;
});
</script>

<style scoped>
/* Pulsed ring behind the icon */
.pulse-ring {
  position: absolute;
  inset: 0;
  border-radius: 22px;
  background-color: #cef1f3;
  z-index: 0;
  animation: pulse-ring 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 #cef1f3;
    opacity: 1;
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px #cef1f3;
    opacity: 0;
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 #cef1f3;
    opacity: 0;
  }
}
</style>
